const contractorsMixin = {
  methods: {
    async apiContractorsGetList (params = {}, $axios = null) {
      $axios = $axios ?? this.$axios
      return await $axios.get('/contractors/list', { params }).then((res) => {
        return res?.data
      }, (err) => {
        return err?.response?.data
      })
    },
    async apiContractorsGetPublicProfile (uuid, $axios = null) {
      const params = { uuid }
      $axios = $axios ?? this.$axios
      return await $axios.get('/contractors/get-public', { params }).then((res) => {
        return res?.data
      }, (err) => {
        return err?.response?.data
      })
    }
  }
}

export default contractorsMixin
